import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../contexts';
import {
  SidebarContainer,
  FilterHeader,
  FilterTitle,
  SectionContainer,
  SectionHeader,
  SectionContent,
  CheckboxContainer,
  CheckboxInput,
  CheckboxLabel,
  RadioContainer,
  RadioInput,
  RadioLabel,
} from './OrdersSidebar.styled';

const FilterSection = ({ title, children, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <SectionContainer>
      <SectionHeader isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <span>{title}</span>
        <i className="mdi mdi-chevron-down" />
      </SectionHeader>
      <SectionContent isOpen={isOpen}>{children}</SectionContent>
    </SectionContainer>
  );
};

FilterSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
};

const OrdersSidebar = ({
  statusOptions = [],
  statusValue = [],
  onStatusChange,
  scope = 'mine',
  onScopeChange,
}) => {
  const { t } = useTranslation();
  const { isAdmin } = useAuth();
  
  const handleStatusToggle = (value) => {
    const newValue = statusValue.includes(value)
      ? statusValue.filter((v) => v !== value)
      : [...statusValue, value];
    onStatusChange(newValue);
  };

  return (
    <SidebarContainer>
      <FilterHeader>
        <FilterTitle>
          <i className="mdi mdi-filter-variant" />
          {t('filters')}
        </FilterTitle>
      </FilterHeader>

      <FilterSection title={t('orderScope')} defaultOpen={true}>
        <RadioContainer checked={scope === 'mine'} onClick={() => onScopeChange('mine')}>
          <RadioInput
            type="radio"
            name="scope"
            value="mine"
            checked={scope === 'mine'}
            onChange={() => onScopeChange('mine')}
          />
          <RadioLabel checked={scope === 'mine'}>
            <i className="mdi mdi-account" />
            {t('myOrders')}
          </RadioLabel>
        </RadioContainer>

        <RadioContainer checked={scope === 'department'} onClick={() => onScopeChange('department')}>
          <RadioInput
            type="radio"
            name="scope"
            value="department"
            checked={scope === 'department'}
            onChange={() => onScopeChange('department')}
          />
          <RadioLabel checked={scope === 'department'}>
            <i className="mdi mdi-account-group" />
            {t('departmentOrders')}
          </RadioLabel>
        </RadioContainer>

        {isAdmin && (
          <RadioContainer checked={scope === 'all'} onClick={() => onScopeChange('all')}>
            <RadioInput
              type="radio"
              name="scope"
              value="all"
              checked={scope === 'all'}
              onChange={() => onScopeChange('all')}
            />
            <RadioLabel checked={scope === 'all'}>
              <i className="mdi mdi-format-list-bulleted" />
              {t('allOrders')}
            </RadioLabel>
          </RadioContainer>
        )}
      </FilterSection>

      <FilterSection title={t('orderStatus')} defaultOpen={true}>
        {statusOptions.map((option) => (
          <CheckboxContainer key={option.value}>
            <CheckboxInput
              type="checkbox"
              checked={statusValue.includes(option.value)}
              onChange={() => handleStatusToggle(option.value)}
            />
            <CheckboxLabel checked={statusValue.includes(option.value)}>
              {option.label}
            </CheckboxLabel>
          </CheckboxContainer>
        ))}
      </FilterSection>
    </SidebarContainer>
  );
};

OrdersSidebar.propTypes = {
  statusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    })
  ),
  statusValue: PropTypes.array,
  onStatusChange: PropTypes.func,
  scope: PropTypes.oneOf(['mine', 'department', 'all']),
  onScopeChange: PropTypes.func,
};

export default OrdersSidebar;


